// Copyright 2005-2011 Jim Radford <radford@blackbean.org> All rights reserved.

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile,
                              in_suit_order=piles.in_suit_order, queen=piles.queen, ace=piles.ace,
                              drag_max_given_free=piles.drag_max_given_free, up=piles.up,
                              score_order_by=piles.score_order_by;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE;
var lib = require('./lib'), map=lib.map;

solitaire.maze = class extends pile_game {
    constructor() {
        super();
        this.pile_game_init(...arguments);
        this.snake = [];
        for (var c=1; c<=54; c++) {
            var seg = new this.segment("snake"+c, this);
            seg.i = c-1;
            this.snake.push(seg);
        }
    }
    in_maze_order(card1, card2) { return in_suit_order(card1,card2)
                                         || card1.rank == queen && card2.rank == ace; }

    segment = class extends pile {
        accept(card) {
                    var prev = this.game.snake[(this.game.snake.length+this.i-1)%this.game.snake.length];
                    var next = this.game.snake[(this.game.snake.length+this.i+1)%this.game.snake.length];
                    return this.pile.length == 0 &&
                           (prev.pile.length && this.game.in_maze_order(prev.top(), card) ||
                            next.pile.length && this.game.in_maze_order(card, next.top()));
        }
        can_drag(index) { return true; }
        xoffset = 0;
        yoffset = 0;
    }

    deal(deck) {
            this.deck = deck;
            for (var c=0; c<52; c++) {
                this.deck[c].face = up;
                var slot = c >= 16 ? c+2 : c >= 8 ? c+1 : c;
                if (this.deck[c].rank != 13)
                    this.snake[slot].push(this.deck[c]);
            }
    }

    is_complete() {
            return this.score() == 48 ? WON : NOT_COMPLETE;
    }

    score() {
            var complete=WON;
            var pile = [];
            var me=this, next = function(i) { while (++i<me.snake.length && me.snake[i].pile.length==0); return i; }
            for (var i=next(-1),j=next(i),f=1; j<this.snake.length; j=next(i=j),f=0) {
                if (f && this.snake[i].top().rank != ace) complete=NOT_COMPLETE; // check for a queen at the end is implicit
                if (!this.in_maze_order(this.snake[i].top(), this.snake[j].top()))
                    complete=NOT_COMPLETE;
                // Weird loop goes through snake.length-1 times, so need special case on start to catch all cards.
                if (f && this.snake[i].top()) pile.unshift(this.snake[i].top());
                pile.unshift(this.snake[j].top());
            }
            return complete == WON ? 48 : score_order_by(in_suit_order, pile);
    }

    layout = grid.apply(this, map(r => map(c => "snake"+(r*9+c+1),
                                           [0,1,2,3,4,5,6,7,8]),
                                  [0,1,2,3,4,5]));
}

module.exports = solitaire.maze;
// Copyright 2005-2011 Jim Radford <radford@blackbean.org> All rights reserved.

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile,
                              in_suit_order=piles.in_suit_order, queen=piles.queen, ace=piles.ace,
                              drag_max_given_free=piles.drag_max_given_free, up=piles.up,
                              score_order_by=piles.score_order_by;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE;
var lib = require('./lib'), map=lib.map;

solitaire.maze = class extends pile_game {
    constructor() {
        super();
        this.pile_game_init(...arguments);
        this.snake = [];
        for (var c=1; c<=54; c++) {
            var seg = new this.segment("snake"+c, this);
            seg.i = c-1;
            this.snake.push(seg);
        }
    }
    in_maze_order(card1, card2) { return in_suit_order(card1,card2)
                                         || card1.rank == queen && card2.rank == ace; }

    segment = class extends pile {
        accept(card) {
                    var prev = this.game.snake[(this.game.snake.length+this.i-1)%this.game.snake.length];
                    var next = this.game.snake[(this.game.snake.length+this.i+1)%this.game.snake.length];
                    return this.pile.length == 0 &&
                           (prev.pile.length && this.game.in_maze_order(prev.top(), card) ||
                            next.pile.length && this.game.in_maze_order(card, next.top()));
        }
        can_drag(index) { return true; }
        xoffset = 0;
        yoffset = 0;
    }

    deal(deck) {
            this.deck = deck;
            for (var c=0; c<52; c++) {
                this.deck[c].face = up;
                var slot = c >= 16 ? c+2 : c >= 8 ? c+1 : c;
                if (this.deck[c].rank != 13)
                    this.snake[slot].push(this.deck[c]);
            }
    }

    is_complete() {
            return this.score() == 48 ? WON : NOT_COMPLETE;
    }

    score() {
            var complete=WON;
            var pile = [];
            var me=this, next = function(i) { while (++i<me.snake.length && me.snake[i].pile.length==0); return i; }
            for (var i=next(-1),j=next(i),f=1; j<this.snake.length; j=next(i=j),f=0) {
                if (f && this.snake[i].top().rank != ace) complete=NOT_COMPLETE; // check for a queen at the end is implicit
                if (!this.in_maze_order(this.snake[i].top(), this.snake[j].top()))
                    complete=NOT_COMPLETE;
                // Weird loop goes through snake.length-1 times, so need special case on start to catch all cards.
                if (f && this.snake[i].top()) pile.unshift(this.snake[i].top());
                pile.unshift(this.snake[j].top());
            }
            return complete == WON ? 48 : score_order_by(in_suit_order, pile);
    }

    layout = grid.apply(this, map(r => map(c => "snake"+(r*9+c+1),
                                           [0,1,2,3,4,5,6,7,8]),
                                  [0,1,2,3,4,5]));
}

module.exports = solitaire.maze;
